
// src/connects/right-side-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import { hashHistory } from 'react-router'
import isNaN from 'lodash/isNaN'

export const mapStateToProps = (state)=> {
  return {
    route: state.routing,
    rightSidePage: state.rightSidePage.name,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    closeRightSidePage: (props)=> {
      if (props && !props.rightSidePage && props.route && props.route.locationBeforeTransitions) {
        const pathname = props.route.locationBeforeTransitions.pathname
        const paths = pathname.split('/')
        !isNaN(parseInt(paths[paths.length - 1])) && paths.pop()
        
        hashHistory.push(
          paths.slice(0, paths.length - 1).join('/')
        )
      } else {
        dispatch(actions.closeRightSidePage())
      }
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/right-side-page.js